import { FC } from "react";
import { Box, NumberInput, Stack, Text } from "@mantine/core";
import { FilterComponentProps } from ".";

const LastCheckInFilter: FC<FilterComponentProps> = ({
  onFilterControlChange,
  filterControl
}) => {

  return (
    <Box mt="xl" h="90%" pos="relative">
      <Stack align="center">
        <Text>
          between
        </Text>
        <NumberInput
          w="80px"
          hideControls
          value={filterControl?.minDaysSinceLastCheckIn || 0}
          onChange={(e) => onFilterControlChange({
            ...filterControl,
            minDaysSinceLastCheckIn: e as number,
          })}
          thousandSeparator=","
          decimalSeparator="."
          inputMode="decimal"
          ml={-30}
          styles={{
            input: {
              fontSize: 24,        // ← stops iOS zoom
              paddingTop: 0,
              paddingBottom: 0,
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              textAlign: "center",
            },
          }} />
        <Text>
          Days
        </Text>
        <Text>
          to
        </Text>
        <NumberInput
          w="80px"
          hideControls
          value={filterControl?.maxDaysSinceLastCheckIn || 0}
          onChange={(e) => onFilterControlChange({
            ...filterControl,
            maxDaysSinceLastCheckIn: e as number,
          })}
          thousandSeparator=","
          decimalSeparator="."
          inputMode="decimal"
          ml={-30}
          styles={{
            input: {
              fontSize: 24,        // ← stops iOS zoom
              paddingTop: 0,
              paddingBottom: 0,
              borderTop: "none",
              borderLeft: "none",
              borderRight: "none",
              textAlign: "center",
            },
          }} />
        <Text>
          Days
        </Text>
      </Stack>
      {filterControl.isCheckInFilterActive && (
        <Text c="#FF9D00" ta="center" fw="bold" w={280} pos="absolute"
          bottom={50}
          style={{
            left: "50%",
            transform: "translateX(-50%)"
          }}>
          Filtering applied -- showing only pins that have valid check-ins
        </Text>
      )}
    </Box>
  );
};

export default LastCheckInFilter;